import React from 'react';
import Pagination from 'rc-pagination';
import './PaginationStyle.css';

type PaginationProps = {
  handlePageChange: (page: number) => void;
  pageCount: number;
  currentPage: number;
};

const PaginationUI: React.FC<PaginationProps> = ({ handlePageChange, pageCount, currentPage }) => (
  <Pagination
    total={pageCount}
    pageSize={1}
    current={currentPage}
    onChange={handlePageChange}
    nextIcon={'>'}
    prevIcon={'<'}
  />
);

export default PaginationUI;
